import { distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface Briefing {
    id: string,
    briefingTitle: string
}

export interface User {
    id?: string
}

export interface State {
    briefings: Briefing[]
    user: User
}

const defaultState: State = {
    briefings: [],
    user: {}
};

const _store = new BehaviorSubject<State>(defaultState);

@Injectable({ providedIn: 'root' })
export class Store {
    private store = _store;
    changes = this.store.asObservable().pipe(distinctUntilChanged());

    setState(state: State){
        this.store.next(state);
    }

    getState(): State{
        return this.store.value;
    }

    purge(){
        this.store.next(defaultState);
    }
}
